export const MAX_FILE_SIZE = 100 * 1024 * 1024
// Apenas .xlsx: é o formato dos templates disponibilizados ao usuário
export const EXTENSOES_ACEITAS = ['.xlsx']

export const ATIVO_TIPOS_VALIDOS = ['VEICULO', 'MAQUINA', 'CAÇAMBA', 'IMOVEL', 'PRENSA']

export const ATIVO_TIPOCONSUMO_VALIDOS = ['1', '2', '3']

export const ATIVO_TIPOVEICULO_VALIDOS = [
  '01WEB', 'BI-TREM', 'BROOK', 'CAMINHONETE', 'CARRETA', 'CARRO', 'CARROCERIA',
  'CAÇAMBA', 'CONTAINER', 'FARDO', 'GARRA', 'KOMBI', 'MUNCK', 'PLATAFORMA',
  'POLIGUINDASTE', 'ROMEU E JULIETA', 'SOLTO', 'SYGECOM', 'TM P', 'TOCO',
  'TRUCK', 'TRUCK D25 T1', 'TRUCK D27', 'VEIC NOVO', 'VEIC WEB01', 'VEIC WEB02',
  'VEIC WEB03', 'VEIC WEB04', 'VEIC WEB05'
]

// Usados tanto na validação local quanto nos templates Excel (generate-templates.js)
export const UFS_VALIDAS = new Set([
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
  'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN',
  'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
])

// Tipos de produto conforme tabela fiscal do sistema legado
export const TP_PROD_VALIDOS = [
  '00', '01', '02', '03', '04', '05', '06', '07', '08',
  '09', '10', '11', '12', '13',
  '99' // Outras (fora da sequência, código especial do legado)
]

// Campos numéricos (ativos) editáveis no grid de correção — valor, peso, capacidade,
// média e ano. Não aceitam valores negativos.
export const CAMPOS_NUMERICOS = new Set([
  'ativo_valativo', 'ativo_tara', 'ativo_capacidade', 'ativo_mediapadrao', 'ativo_ano'
])

export const isCampoNumerico = (campo: string): boolean => CAMPOS_NUMERICOS.has(campo)

// Campos mantidos como texto (preservam zeros à esquerda) mas que só aceitam dígitos
export const CAMPOS_SOMENTE_DIGITOS = new Set(['cep'])

export const isCampoSomenteDigitos = (campo: string): boolean => CAMPOS_SOMENTE_DIGITOS.has(campo)
